module.exports = __webpack_public_path__ + "static/media/image_5x2.2e5e211a.png";